import React,{Component} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import MDBox from '../MDBox';
import DashboardLayout from "../examples/LayoutContainers/DashboardLayout/index";
import DashboardNavbar from "../examples/Navbars/DashboardNavbar";
import { getToken } from '../../util';
export default class Reports extends Component{
    constructor(){
        super()
        this.state={
            columns : [
                { field: 'firstname', headerName: 'NAME', width: 180, editable: false ,},
                { field: 'emailid', headerName: 'MAILID',  width: 280,editable: false  },
                { field: 'productkey', headerName: 'PRODUCTKEY', width: 180, editable: false ,},
                { field: 'phonenumber', headerName: 'MOBILENO', width: 180, editable: false ,},
                { field: 'companyname', headerName: 'COMPANY NAME', width: 180, editable: false ,},
                { field: 'companyaddress', headerName: 'ADDRESS', width: 180, editable: false ,},
                { field: 'companycity', headerName: 'CITY', width: 180, editable: false ,},
                { field: 'pincode', headerName: 'PINCODE', width: 180, editable: false ,},
                { field: 'companypanno', headerName: 'PANNO', width: 180, editable: false ,},
                { field: 'companygstno', headerName: 'GSTNO', width: 180, editable: false ,},
                { field: 'softwarename', headerName: 'PRODUCT', width: 180, editable: false ,},
                { field: 'softwareidentificationname', headerName: 'IDENTIFICATION NAME', width: 180, editable: false ,},
                { field: 'supportpin', headerName: 'SUPPORT PIN', width: 180, editable: false ,},
                { field: 'noofsystem', headerName: 'NO.OF.SYSTEM', width: 180, editable: false ,},  
                { field: 'noofmobileuser', headerName: 'NO.OF.MOBILEUSER', width: 180, editable: false ,},
                
               
            ],
            rows :[]
        }
    }
    componentDidMount=()=>{
        this.getLicenseDetails()
    }
    getLicenseDetails=()=>{
        this.setState({rows:[]})
        fetch(`eadmin/v1/set/get_license_details`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "x-access-token":getToken(),
          },
          }).then((response) => response.json())
          .then((responseJson) => {
          if(responseJson.status && responseJson.result.length>0){
            let id=1,data=[]
            for(var i=0;i<responseJson.result.length;i++){
              let tempdata={...responseJson.result[i],id:id,}
              id++
              data.push(tempdata)
            }
            this.setState({rows:data})
          }else if(!responseJson.status){
            alert(responseJson.errorMsg)
          }
        }).catch((error) => {
          alert(error)
        });
    }
    render(){
        return(
            <DashboardLayout>
            <DashboardNavbar />
            <MDBox display="flex" justifyContent="space-between" alignItems="center" >
            <Paper sx={{width:'100%'}}>
                <div style={{ height: 800, width:'100%' }}>
                <DataGrid
                    sx={{
                    boxShadow: 2,
                    border: 2,
                    borderColor: '#4A148C',
                    fontWeight:'600',
                    '& .MuiDataGrid-cell:hover': {
                        color: '900',
                    },
                    }}
                    rows={this.state.rows}
                    columns={this.state.columns}
                />
                </div>
            </Paper>
            </MDBox>
            </DashboardLayout>
        )
    }
}